import './App.css';

import Bar from './components/Bar';
import Stat from './components/Stat';

function App() {
  return (
    <div className="App">
      <Bar />
      <Stat />
    </div>
  );
}

export default App;
